// extracted by mini-css-extract-plugin
module.exports = {"img-container":"Blog_img-container__3DrgL"};